module.exports = __webpack_public_path__ + "img/ico_d_arrow_2.1c5c97ff.svg";